import { useTranslation } from 'react-i18next';
import Reveal from '@/components/base/Reveal';

export default function MaterialsSection() {
  const { t } = useTranslation();
  const materials = t('processing.materials.items', { returnObjects: true }) as string[];

  return (
    <section className="relative overflow-hidden bg-foreground-950 py-16 md:py-24">
      <div
        className="pointer-events-none absolute inset-0 opacity-[0.05]"
        style={{
          backgroundImage:
            'linear-gradient(oklch(var(--background-50)) 1px, transparent 1px), linear-gradient(90deg, oklch(var(--background-50)) 1px, transparent 1px)',
          backgroundSize: '60px 60px',
        }}
      />
      <div className="relative mx-auto grid w-full max-w-content grid-cols-1 gap-12 px-4 md:px-6 lg:grid-cols-12 lg:gap-16">
        <Reveal className="lg:col-span-5">
          <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em] text-primary-300">
            <span className="h-px w-6 bg-current" />
            {t('processing.materials.eyebrow')}
          </span>
          <h2 className="mt-4 text-2xl font-bold leading-tight text-background-50 md:text-4xl">
            {t('processing.materials.title')}
          </h2>
          <p className="mt-5 text-base leading-relaxed text-background-200">
            {t('processing.materials.subtitle')}
          </p>
        </Reveal>

        <Reveal delay={120} className="lg:col-span-7">
          <div className="flex flex-wrap gap-3">
            {materials.map((material) => (
              <span
                key={material}
                className="inline-flex items-center gap-2 rounded-full border border-background-50/15 bg-foreground-900/60 px-5 py-3 text-sm font-medium text-background-100"
              >
                <i className="ri-stack-line text-base text-accent-400" />
                {material}
              </span>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}